export default __webpack_public_path__ + "static/media/Glossary.9387aece.svg";